import { deepFreeze } from '@/utils/deepFreeze';

export const PHYSICS_CONFIG = deepFreeze({
  // Movement
  DEFAULT_SPEED: 20,
  FRICTION: 0.975,
  MIN_VELOCITY: 0.01,

  // Pathfinding
  PATH_ARRIVAL_THRESHOLD: 0.5,
  PATH_ARRIVAL_MIN: 0.1,
  WALL_BUFFER_MULTIPLIER: 1.5,

  // Lodge Recruitment
  BACKTRACKING_DISCOUNT: 0.3,

  // Spawning
  POSITION_JITTER: 20,
  REDIRECT_JITTER_DIVISOR: 4,

  // Combat
  WALL_COLLISION_THRESHOLD: 0.1,
  KNOCKBACK_FRICTION: 0.92,
  MAX_KNOCKBACK_VELOCITY: 200,
  DEATH_ANIMATION_DURATION: 500,
  STRUCTURE_DEATH_ANIMATION_DURATION: 800,
  STRUCTURE_DEATH_FLICKER_END: 0.4,
  STRUCTURE_DEATH_SHRINK_END: 0.7,

  // Goals
  GOAL_ARRIVAL_DISTANCE: 50,

  // Trails
  TRAIL_VELOCITY_THRESHOLD: 0.1,

  // Building
  BUILD_SITE_RADIUS: 20,

  // Spatial Partitioning
  SPATIAL_GRID_CELL_SIZE: 150
});
